import React from 'react';
import InventorySearch from '../../components/inventory/InventorySearch/InventorySearch';
import './Inventory.css';

const Inventory = () => {
  return (
    <div className="inventory-page">
      <InventorySearch />
    </div>
  );
};

export default Inventory;
